var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfomenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 13.0302C8.17281 13.0302 7.50006 13.7029 7.50006 14.5302C7.50006 15.3574 8.17281 16.0302 9.00006 16.0302C9.82731 16.0302 10.5001 15.3574 10.5001 14.5302C10.5001 13.7029 9.82731 13.0302 9.00006 13.0302Z",
    fill: "#1C7CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 5.53015C9.82731 5.53015 10.5001 4.8574 10.5001 4.03015C10.5001 3.2029 9.82731 2.53015 9.00006 2.53015C8.17281 2.53015 7.50006 3.2029 7.50006 4.03015C7.50006 4.8574 8.17281 5.53015 9.00006 5.53015Z",
    fill: "#1C7CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 7.78015C8.17281 7.78015 7.50006 8.4529 7.50006 9.28015C7.50006 10.1074 8.17281 10.7802 9.00006 10.7802C9.82731 10.7802 10.5001 10.1074 10.5001 9.28015C10.5001 8.4529 9.82731 7.78015 9.00006 7.78015Z",
    fill: "#1C7CF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfomenu);
export default __webpack_public_path__ + "static/media/Info menu.6adb0c839c93bdf1bc23b75d78c8ab97.svg";
export { ForwardRef as ReactComponent };